import { FiArrowLeft, FiLock, FiMail, FiRefreshCw } from 'react-icons/fi';
import { AuthShell } from '../_Shared/AuthShell';
import { useAuthLogin } from '../../_Hooks/useAuthLogin';
import { AppSeo } from '../../../../../../_CORE/APP/Templates/_UI/Seo/_index';
import { AppButton } from '../../../../../../_CORE/APP/Templates/_UI/Button/_index';
import { FieldInput, FieldOtp } from '../../../../../../_CORE/APP/Templates/_UI/Form/_index';
import { onLoginContent } from '../../_Resources/Content/Login.Resources';
import { onFieldsContent } from '../../_Resources/Content/Fields.Resources';
import { useLanguage } from '../../../../../../_CORE/APP/Hooks/Contexts/Translate/useLanguageContext';

export const AuthLoginViewMain = () => {
    const { useDataLanguage } = useLanguage();
    const CONTENT = onLoginContent(useDataLanguage.currentLang);
    const FIELDS = onFieldsContent(useDataLanguage.currentLang);
    const {
        LOGIN_FORM, VERIFY_FORM, verification, resendIn, resendCode, backToCredentials,
        isLoginLoading, isVerifyLoading, isResendLoading,
    } = useAuthLogin();

    const isVerificationStep = !!verification?.challengeId;

    return (
        <>
            <AppSeo title={CONTENT.SEO_TITLE} description={CONTENT.SEO_DESCRIPTION} />

            <AuthShell>
                {!isVerificationStep ? (
                    <div className="PBAUTH__card PBAUTH__card--login">
                        <h1 className="PBAUTH__card_title">Acceso autorizado</h1>

                        <form className="PBAUTH__form" onSubmit={LOGIN_FORM.onSubmit} autoComplete="off" noValidate>
                            <FieldInput {...LOGIN_FORM.field('email')} type="email" span={2}
                                label={FIELDS.EMAIL_LABEL} placeholder={FIELDS.EMAIL_PLACEHOLDER}
                                iconStart={<FiMail />} isDisabled={isLoginLoading} />

                            <FieldInput {...LOGIN_FORM.field('password')} type="password" span={2}
                                label={FIELDS.PASSWORD_LABEL} placeholder={FIELDS.PASSWORD_PLACEHOLDER}
                                iconStart={<FiLock />} isDisabled={isLoginLoading} />

                            <div className="PBAUTH__submit_row">
                                <AppButton className="PBAUTH__submit" type="submit" size="lg" isLoading={isLoginLoading}>
                                    {isLoginLoading ? 'Ingresando' : CONTENT.SUBMIT}
                                </AppButton>
                            </div>
                        </form>
                    </div>
                ) : (
                    <div className="PBAUTH__card PBAUTH__card--verify">
                        <h1 className="PBAUTH__card_title">Código de seguridad</h1>
                        {verification?.recipient && (
                            <p className="PBAUTH__card_hint">Enviado a {verification.recipient}</p>
                        )}

                        <form className="PBAUTH__form" onSubmit={VERIFY_FORM.onSubmit} autoComplete="off" noValidate>
                            <FieldOtp {...VERIFY_FORM.fieldValue('code')} name="code" length={6} span={2}
                                label="Código de verificación"
                                isDisabled={isVerifyLoading} />

                            <div className="PBAUTH__submit_row">
                                <AppButton className="PBAUTH__submit" type="submit" size="lg" isLoading={isVerifyLoading}>
                                    {isVerifyLoading ? 'Verificando' : 'Confirmar acceso'}
                                </AppButton>
                            </div>
                        </form>

                        <div className="PBAUTH__verify_actions">
                            <button type="button" onClick={backToCredentials} disabled={isVerifyLoading || isResendLoading}>
                                <FiArrowLeft /> Volver
                            </button>
                            <button type="button" onClick={resendCode} disabled={resendIn > 0 || isResendLoading || isVerifyLoading}>
                                <FiRefreshCw /> {isResendLoading ? 'Enviando...' : resendIn > 0 ? `Reenviar en ${resendIn}s` : 'Reenviar código'}
                            </button>
                        </div>
                    </div>
                )}
            </AuthShell>
        </>
    );
};
